import styled from 'styled-components'

const Loading = ({  }) => (
  <S_Loading>
    
  </S_Loading>
)

export default Loading

const S_Loading = styled.div`
  display: flex;
  width: 480px;
  height: 360px;
  justify-content: center;
  background-image: url('/loading-spinner-black.gif');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 480px 360px;
`